/** Wait for the actual frame's art-directed images, CSS artwork and fonts. */
export async function waitForPreviewAssets(root: ParentNode = document): Promise<void> {
  const paint = () => new Promise<void>(resolve => requestAnimationFrame(() => resolve()));
  await document.fonts.ready;
  await paint();
  const images = [...root.querySelectorAll('img')];
  images.forEach(image => { image.loading = 'eager'; });
  const urls = new Set<string>();
  for (const element of root.querySelectorAll('*')) {
    const style = getComputedStyle(element);
    for (const value of [style.backgroundImage, style.content]) {
      for (const match of value.matchAll(/url\(["']?([^"')]+)["']?\)/g)) {
        if (!match[1].startsWith('#')) urls.add(match[1]);
      }
    }
    if (element instanceof SVGImageElement) {
      const href = element.href.baseVal;
      if (href && !href.startsWith('#')) urls.add(href);
    }
  }
  await Promise.all([
    ...images.map(image => image.decode()),
    ...[...urls].map(async url => {
      const image = new Image();
      image.src = url;
      await image.decode();
    }),
  ]);
  await document.fonts.ready;
  await paint();
  await paint();
}
